// The collection sidebar doubles as a mobile drawer (via .js-offcanvas).
// When the drawer is collapsed, the offcanvas state machine sets `inert`
// and `aria-hidden` on it. On desktop the same element is a static sidebar
// that must always be interactive, so we strip those attributes whenever
// we're at desktop width.
const sidebar = document.querySelector('.collection__sidebar .js-offcanvas');

if (sidebar) {
  const unInert = () => {
    if (window.innerWidth >= 1024) {
      sidebar.removeAttribute('inert');
      sidebar.removeAttribute('aria-hidden');
    }
  };

  unInert();
  window.matchMedia('(min-width: 1024px)').addEventListener('change', unInert);
  new MutationObserver(unInert).observe(sidebar, {
    attributes: true,
    attributeFilter: ['inert'],
  });
}
